import type { FC } from "react";
import React from "react";
import { Body, Box, Pill } from "@edreamsodigeo/prisma-design-system";
import { useBrand } from "@edreamsodigeo/frontend-core";

import { FareCardHeaderCTANoButton } from "./OfferCardHeaderCTANoButton";
import {
  getFareCardBorderStyle,
  pillBackground,
} from "~/components/common/FareCard/styles/styles";
import type { FareCardNoButtonProps } from "~/components/common/FareCard/contract";

export const FareCardCTANoButton: FC<FareCardNoButtonProps> = ({
  type = "primary",
  fareTitle,
  fareSubtitle,
  farePrice,
  fareDiscountedPrice,
  farePriceDescription,
  pillLabel,
  onClick,
  isAutoRenewalPolicy,
}) => {
  const brand = useBrand();
  const primaryCard = type === "primary";
  const showPill = primaryCard && pillLabel;
  const bgColor = primaryCard ? "primary.50" : "neutral.0";

  const borderStyle = getFareCardBorderStyle(primaryCard);

  return (
    <Box
      border={borderStyle.width}
      borderColor={borderStyle.color}
      paddingX={"base"}
      paddingTop={"base"}
      borderRadius={"regular"}
      onClick={onClick}
      backgroundColor={bgColor}
      sx={{
        boxShadow: primaryCard && "0px 0px 4px rgba(0,0,0,0.25)",
        ":hover": {
          backgroundColor: primaryCard && "primary.70",
          borderColor: primaryCard && "primary.90",
        },
      }}
    >
      {showPill && (
        <Box position={"relative"}>
          <Box position={"absolute"} sx={{ top: "-28px", right: "0" }}>
            <Pill
              sx={pillBackground[brand]?.sx}
              type={pillBackground[brand]?.type}
              rounded
            >
              <Body type={"xSmall"}>{pillLabel}</Body>
            </Pill>
          </Box>
        </Box>
      )}

      <Box>
        <FareCardHeaderCTANoButton
          title={fareTitle}
          subtitle={fareSubtitle}
          price={farePrice}
          discountedPrice={fareDiscountedPrice}
          priceDescription={farePriceDescription}
          type={type}
          isAutoRenewalPolicy={isAutoRenewalPolicy}
        />
      </Box>
    </Box>
  );
};
